'use client'

import { useTranslations } from 'next-intl'
import { motion } from 'framer-motion'
import { Link } from '@/i18n/navigation'
import { Container } from '@/components/ui/container'
import { Eyebrow } from '@/components/ui/eyebrow'
import { Heading } from '@/components/ui/heading'
import { Text } from '@/components/ui/text'
import { Button } from '@/components/ui/button'
import { CalendlyButton } from '@/components/ui/calendly-button'
import { GradientText } from '@/components/ui/gradient-text'
import { Stat } from '@/components/ui/stat'

const stats = [
  { value: '150+', label: 'Sites & Apps Shipped' },
  { value: '95+', label: 'Core Web Vitals' },
  { value: '4–6 wks', label: 'Typical MVP' },
  { value: '99.9%', label: 'Uptime SLA' },
]

export function WebDevHero() {
  const t = useTranslations('webDev.hero')

  return (
    <section
      id="hero"
      className="relative flex min-h-screen flex-col overflow-hidden pt-36 bg-white"
    >
      <div className="flex flex-1 items-center">
        <Container>
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: 'easeOut' }}
            className="max-w-4xl flex flex-col gap-6"
          >
            <Eyebrow dot className="self-start">
              {t('eyebrow')}
            </Eyebrow>
            <Heading as="h1" size="h1">
              {t('titleLine1')}
              <br />
              {t('titleLine2')}
              <br />
              <GradientText>{t('titleGradient')}</GradientText>
            </Heading>
            <Text size="xl" tone="muted" className="max-w-2xl">
              {t('description')}
            </Text>
            <div className="flex flex-wrap gap-3">
              <Button asChild size="lg">
                <Link href="#contact">{t('ctaStart')}</Link>
              </Button>
              <CalendlyButton size="lg" variant="outline">
                {t('ctaBook')}
              </CalendlyButton>
            </div>
          </motion.div>
        </Container>
      </div>

      <div
        aria-hidden
        className="pointer-events-none absolute -right-40 top-20 h-[500px] w-[500px] rounded-full bg-[radial-gradient(circle_at_center,rgba(43,90,255,0.2),transparent_60%)]"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute -left-40 bottom-0 h-[400px] w-[400px] rounded-full bg-[radial-gradient(circle_at_center,rgba(160,32,200,0.15),transparent_60%)]"
      />
    </section>
  )
}
